import React, { useState, useEffect } from 'react';
import { Divider } from 'antd';
import  PropTypes from 'prop-types';
import moment from 'moment';
import { withRouter } from 'react-router-dom'; 
import {
    SectionSpacing,
    PageSectionHeading,
    SectionSubHeading,
} from '../../../../../../CommonComponents/commonStyles';
import { getAccountData } from '../../../../../../utils/sessionUtil';
import { updateSingleExchange, updateRecurringExchange, editExchangeSpawnByScheduleId } from '../../../../../../services/apiServices';
import Table from './Table';
import ScheduleOptions from './ScheduleOptions';
import { FromNavigationBtnContainer } from './styles';
import Context from '../../context';
import Blur from './Blur';
import {
    ScheduleType as ScheduleTypeConstants,
    ExchangeType as ExchangeTypeConstants,
    AllocationType as AllocationTypeConstants,
    DateFormat,   
    Frequency as FrequencyConstants
} from '../../constants';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import queryString from "query-string";
import { checkCSRBusinessFunction } from '../../../../../../CSR/utils/CommonUtils';
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import { initiateTracking, moveIntoErrorPosition, recordError } from '../../../../../../utils/commonUtil';
import { AlertMessage } from '../popup';
import { GeneralButton } from '../../../../../../CommonComponents/Commons/commonComponents';

// Check the feature is avalilable by the particular csr user
export const checkCsrBusiness = (businessFunction, csrBusinessFunction) => {
    return checkCSRBusinessFunction(BUSINESS_FUNCTION[businessFunction], csrBusinessFunction);
}

export const ExchangeFrom = (props) => {    
    const { investmentPoolOptions, history, location, exchangeType, changeExchangeType,
        handleExit, handleCancel, scheduleType, edit, id, persistContext, isDirty, isNew, setDirty: setParentDirty,
        exchangeDetails, userId, spawnRange, isSpawn, resetContext, handleCancelConfirmation, exchPendingSpawnId, csrBusinessFunction } = props;
    const { partyId } = getAccountData();
    const { exchangeContext={}, setExchangeContext={} } = React.useContext(Context);
    const { from={}, to={} } = exchangeContext;        
    const [isEnabled, setEnabled] = useState(() => {
        let isEnable = edit || id !== 'NEW' || Boolean(exchangeType);
        if (exchangeType) {
            isEnable = scheduleType === ScheduleTypeConstants.recurring ? Boolean(from.endDate) : true;
        }
        return isEnable;
    });   
    const [frequency, setFrequency] = useState(from.frequency);
    const [startDate, setStartDate] = useState(from.startDate);
    const [numberOfExchanges, setNumberOfExchanges] = useState(from.numberOfExchanges);
    const [endDate, setEndDate] = useState(from.endDate);
    const [isError, setError] = useState(false);
    const isRecurringDisabled = scheduleType === ScheduleTypeConstants.recurring && numberOfExchanges < 2;
     /** Error state */
    const [focusedOutExchangeType, setFocusedOutExchangeType] = useState(false);
    const [focusedOutFrequency, setFocusedOutFrequency] = useState(false);
    const [focusedOutStartDate, setFocusedOutStartDate] = useState(false);
    const [focusedOutNumberOfExchanges, setFocusedOutNumberOfExchanges] = useState(false);
    const [focusedOutSpawnDate, setFocusedOutSpawnDate] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
     /** Only Mount and un-mount effect for scrolling don't add anything here */
    useEffect(() => {        
        window.scrollTo(0, 0);
    }, []);
    /** Calculate end date as per selection */
    useEffect(() => {        
        if(!isSpawn) {
            let end = startDate ? moment(startDate, DateFormat) : undefined;                        
            if (startDate && frequency) {
                if(numberOfExchanges){
                    if (frequency === FrequencyConstants.quaterly) {
                        end && end.add(Number(numberOfExchanges) - 1, 'Q')                        
                    } else if (frequency === FrequencyConstants.monthly) {
                        end && end.add(Number(numberOfExchanges) - 1, 'M')                        
                    } else if (frequency === FrequencyConstants.weekly) {
                        end && end.add(Number(numberOfExchanges) - 1, 'w')                        
                    }                   
                    setEndDate(end && end.format('MM/DD/YYYY'));                    
                }                
                // Update context
                const tmp = { ...exchangeContext };
                tmp.from.frequency = frequency;
                tmp.from.startDate = startDate; // considering it is a string date with format
                tmp.from.numberOfExchanges = numberOfExchanges;
                tmp.from.endDate = end && end.format(DateFormat);                                                                                   
                setExchangeContext(tmp);
            } else {                
                setEndDate(undefined);
            }
        } else {           
            const tmp = { ...exchangeContext };
            tmp.from.startDate = startDate;                   
            setExchangeContext(tmp);
        }
    }, [frequency, startDate, numberOfExchanges]);

    useEffect(() => {
        let isEnable = edit || id !== 'NEW' || Boolean(exchangeType);
        if (exchangeType) {
            isEnable = scheduleType === ScheduleTypeConstants.recurring ? Boolean(endDate) : true;
        }
        setEnabled(isEnable);
    }, [edit, id, exchangeType, scheduleType, endDate]);

    // Set values of startDate, frequency, numberOfExchanges if context is changed
    useEffect(() => {
        const { from } = exchangeContext;        
        setStartDate(from.startDate);
        setFrequency(from.frequency);
        setNumberOfExchanges(from.numberOfExchanges);
    }, [exchangeContext]);

    const navigateBackToView = (data, isSingle) => {
        const id = isSingle ? data.txnId : data.scheduleId;
        // TODO: Put it in context or ask page to get exchange details as view flow 
        window.sessionStorage.removeItem('recommend-an-exchange');
        const query = queryString.parse(location.search);        
        setParentDirty(false);
        if (isSpawn) {
            history.push({
                pathname: `/investments/recommend-an-exchange/${id}/spawn/${exchPendingSpawnId}/view`,
                search: `type=${query.type}`
            })
        } else {
            history.push({
                pathname: `/investments/recommend-an-exchange/${id}/view`,
                search: `type=${query.type}`
            });
        }
    };   

    // This function is only for existing exchange updates.
    const handleUpdateSubmit = () => {                           
        if(validationCheck() && !checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')) {
            if(exchangeContext.from.pools.length === 0){                               
                setErrorModal(true)
            } else {                
                const data = {
                    partyId: partyId,
                    startDate: from.scheduleType === ScheduleTypeConstants.onetime ? moment().format("MM/DD/YYYY") :
                        from.scheduleType === ScheduleTypeConstants.recurring ? moment(from.startDate).format("MM/DD/YYYY") : '',
                    exchangeType: from.exchangeType === ExchangeTypeConstants.custom ? 'Custom Exchange' :
                        from.exchangeType === ExchangeTypeConstants.reallocation ? 'Reallocation Exchange' : '',
                    category: from.scheduleType === ScheduleTypeConstants.onetime ? 'Single Exchange' :
                        from.scheduleType === ScheduleTypeConstants.recurring ? 'Recurring Exchange' : '',
                    unit: from.exchangeType === ExchangeTypeConstants.reallocation ? 'DOLLAR' :
                        from.allocationType === AllocationTypeConstants.unit ? 'UNITS' :
                            from.allocationType === AllocationTypeConstants.dollar ? 'DOLLAR' :
                                from.allocationType === AllocationTypeConstants.percentage ? 'PERCENT' : '',
                    exchangeFrom: from.pools.map((item) => {
                        return {
                            poolId: item.poolId,
                            pool: item.poolName,
                            value: from.allocationType === AllocationTypeConstants.unit ? item.unit :
                                from.allocationType === AllocationTypeConstants.dollar ? item.dollar :
                                    from.allocationType === AllocationTypeConstants.percentage ? item.percentage : '',
                        };
                    }),
                    exchangeTo: to.pools.map((item) => {
                        return {
                            poolId: item.poolId,
                            pool: item.investmentOption,
                            percentage: item.percentage
                        };
                    }),
                }

                if (from.scheduleType === ScheduleTypeConstants.onetime) {                    
                    data.txnId = exchangeDetails.transactionId;
                } else if (from.scheduleType === ScheduleTypeConstants.recurring) {
                    data.scheduleId = exchangeDetails.exchScheduleId;
                    data.endDate = moment(from.endDate).format("MM/DD/YYYY");
                    data.frequency = from.frequency === FrequencyConstants.weekly ? 'Weekly'
                                : from.frequency === FrequencyConstants.monthly ? 'Monthly'
                            : from.frequency === FrequencyConstants.quaterly ? 'Quarterly' : '';
                    data.startDay = 'Monday';
                    data.numberOfExchanges = from.numberOfExchanges.toString();                    
                }  
                
                if (from.scheduleType === ScheduleTypeConstants.onetime) {                                                        
                    return updateSingleExchange({ accountId: userId, data }).then((res) => {                                                
                        initiateTracking('update', 'View and Edit Exchange', 'Recommend exchange from', 'Update - One Time Exchange');
                        navigateBackToView(data, true);
                    })                    
                } else if (from.scheduleType === ScheduleTypeConstants.recurring) {                                  
                    return updateRecurringExchange({ accountId: userId, data }).then((res) => {
                        initiateTracking('update', 'View and Edit Exchange', 'Recommend exchange from', 'Update - Recurring Exchange');
                        navigateBackToView(data, false);
                    });
                }
            }
        } 
    };

    const handleSpawnUpdateSubmit = () => {
        // here spawn data is coming as exchangeDetails
        const spawnDetails = {...exchangeDetails};
        // FIXME: update spawns API call changes        
        const data = {
            partyId: partyId,
            exchangeStartDate: moment(from.startDate).format("MM/DD/YYYY"),
            instructionType: from.allocationType === AllocationTypeConstants.unit ? 'UNITS' :
                        from.allocationType === AllocationTypeConstants.dollar ? 'DOLLAR' :
                        from.allocationType === AllocationTypeConstants.percentage ? 'PERCENT' : '',
            exchangePendingSpawnId: exchangeDetails.exchangePendingSpawnId,
            exchangeType: exchangeDetails.exchangeType,
            orderId: exchangeDetails.orderId,
            scheduleId: exchangeDetails.scheduleId,
            exchangeId: exchangeDetails.exchangeId,
            exchangeFrom: from.pools.map((item) => {
                return {
                    poolId: item.poolId,
                    pool: item.poolName,
                    value: from.allocationType === AllocationTypeConstants.unit ? item.unit :
                        from.allocationType === AllocationTypeConstants.dollar ? item.dollar :
                            from.allocationType === AllocationTypeConstants.percentage ? item.percentage : '',
                };
            }),
            exchangeTo: to.pools.map((item) => {
                return {
                    poolId: item.poolId,
                    pool: item.investmentOption,
                    percentage: item.percentage
                };
            }), 
        }
        return editExchangeSpawnByScheduleId({ accountId: userId, data: data }).then((res) => {
            initiateTracking('update', 'View and Edit Recurring Exchange Spawn', 'Recommend exchange from', 'Update');
            navigateBackToView(spawnDetails, false);
        });
    }

    const handleUpdate = () => {                
        try {            
            if (isNew) {
                if(validationCheck()) {                    
                    if(exchangeContext.from.pools.length === 0){
                        setErrorModal(true)
                    } else {                        
                        persistContext();
                        if (location && location.state && location.state.prev) {                            
                            history.push({
                                pathname: location.state.prev.pathname,
                                search: location.state.prev.search,
                            });
                        } else {                            
                            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange'
                            initiateTracking('update', 'Recommend An Exchange', 'Step 1 Recommend exchange from', `Update - ${scheduleTypeLabel}`);
                            history.push(`/investments/recommend-an-exchange/${id}/review`)
                        }
                    }
                }
            } else {                
                if (isSpawn) {                    
                    if(validationSpawnCheck()) {                        
                        if(exchangeContext.from.pools.length === 0){
                            setErrorModal(true)
                        } else {
                            handleSpawnUpdateSubmit();
                        }
                    } 
                } else {                    
                    // Call update for the changes
                            handleUpdateSubmit();
                        
                }
            }
        } catch (error) {
            recordError(error);
        }
    };

    const onHandleCancel = () => {
        try {
            const pageTitle = isNew ? 'Recommend An Exchange' : 'View and Edit Exchange';
            const isStep = isNew ? 'Step 1 ': '';
            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
            if(isSpawn) {
                initiateTracking('cancel', 'View and Edit Recurring Exchange Spawn', 'Recommend exchange from', 'Cancel');
            } else {                
                initiateTracking('cancel', `${pageTitle}`, `${isStep}Recommend exchange from`, `Cancel - ${scheduleTypeLabel}`);
            } 
            if (isDirty) {                
                handleCancel()
            } else {                
                handleCancelConfirmation()
            }
        } catch (error) {
          recordError(error);
        }
    }

    const oneTimeValidation = () => {
        if(!exchangeType) {
            setFocusedOutExchangeType(true)
            setTimeout(() => {
                moveIntoErrorPosition(".error-fields");
              });
            return false
       } else {
           return true
       }
    }

    const recurringValidation = () => {
        if(frequency && startDate && (numberOfExchanges && !isRecurringDisabled)) {
            return true;
        } else {
            if(!frequency) {
                setFocusedOutFrequency(true)
                setTimeout(() => {
                    moveIntoErrorPosition(".error-fields", 0);
                  });
                return false
            } else {
                if(!startDate) {
                    setFocusedOutStartDate(true)
                    setTimeout(() => {
                        moveIntoErrorPosition(".error-fields", 1);
                      });
                    return false
                } else {
                    setFocusedOutNumberOfExchanges(true)
                    setTimeout(() => {
                        moveIntoErrorPosition(".error-fields", 2);
                      });
                    return false
                }
            }
            
        }
    }

    
    const validationSpawnCheck = () => {
        
        if(!startDate) {
            setFocusedOutSpawnDate(true)
            setTimeout(() => {
                moveIntoErrorPosition(".error-fields", 1);
              });
            return false
        } else {
           return true
        }
    }


    const validationCheck = (scheduleType) => {
        if(scheduleType === ScheduleTypeConstants.recurring) {
           return recurringValidation()
        } else {
            return oneTimeValidation();
        }
    } 

    const onFromNextClicked = () => {
        try {
            if(validationCheck(scheduleType)) {
                if(exchangeContext.from.pools.length === 0){
                    setErrorModal(true)
                } else {
                    persistContext();
                    history.push(`/investments/recommend-an-exchange/${id}/to`);
                }
            }
        } catch (error) {
          recordError(error);
        }
    }   

    return (
        <>
            <div data-test="exchangeFrom">
                <PageSectionHeading>Schedule</PageSectionHeading>
                <ScheduleOptions
                    data-test="scheduleOptions"
                    exchangeType={exchangeType}
                    scheduleType={scheduleType}
                    handleExchangeTypeChange={(type) => changeExchangeType(type)}
                    frequency={frequency}
                    startDate={startDate}
                    numberOfExchanges={numberOfExchanges}
                    endDate={edit ? from.endDate : endDate}
                    setFrequency={setFrequency}
                    setStartDate={setStartDate}
                    setNumberOfExchanges={setNumberOfExchanges}
                    setEndDate={setEndDate}
                    setDirty={setParentDirty}
                    spawnRange={spawnRange}
                    isSpawn={isSpawn}
                    isNew={isNew}
                    spawnExecutionDate={startDate}
                    isSpawnApproved={from.isSpawnApproved}
                    focusedOutExchangeType={focusedOutExchangeType}
                    focusedOutFrequency={focusedOutFrequency}
                    focusedOutStartDate={focusedOutStartDate}
                    focusedOutNumberOfExchanges={focusedOutNumberOfExchanges}
                    setFocusedOutExchangeType={setFocusedOutExchangeType}
                    setFocusedOutFrequency={setFocusedOutFrequency}
                    setFocusedOutStartDate={setFocusedOutStartDate}
                    setFocusedOutNumberOfExchanges={setFocusedOutNumberOfExchanges}
                    focusedOutSpawnDate={focusedOutSpawnDate}
                    setFocusedOutSpawnDate={setFocusedOutSpawnDate}
                />
            </div>
            <Divider className="m0" />
            <SectionSpacing>
                <div id="recommend-exchange-from">
                    <PageSectionHeading>Recommend exchange from</PageSectionHeading>
                    <SectionSubHeading>
                        Select funds to be exchanged from the existing investment pools.
                    </SectionSubHeading>
                    
                    {!isEnabled && <Blur data-test="blurPoolOptions" isEnabled={isEnabled}>
                        {!(investmentPoolOptions && investmentPoolOptions.investmentPools)
                            && <Preloader />}
                        {(investmentPoolOptions && investmentPoolOptions.investmentPools)
                            && <Table
                                dataSource={investmentPoolOptions.investmentPools}
                                exchangeType={exchangeType}
                                scheduleType={scheduleType}
                                setDirty={setParentDirty}
                                edit={edit}
                                setError={setError}
                            />}
                    </Blur>}
                    {isEnabled && <>
                        {!(investmentPoolOptions && investmentPoolOptions.investmentPools)
                            && <Preloader />}
                        {(investmentPoolOptions && investmentPoolOptions.investmentPools)
                            && <Table
                                dataSource={investmentPoolOptions.investmentPools}
                                exchangeType={exchangeType}
                                scheduleType={scheduleType}
                                setDirty={setParentDirty}
                                edit={edit}
                                setError={setError}
                            />}
                    </>}
                    <SectionSubHeading>
                        * While an exchange recommendation less than 1% of a pool’s available balance appears as 0% in the table, you recommendation will be submitted.
                    </SectionSubHeading>
                </div>
            </SectionSpacing>
            <FromNavigationBtnContainer className="flex justify-between">
                {!edit && <>
                    <GeneralButton type="functional" inverted={true} width="150px" text="Exit" id="btnExit" data-test="btnExit" onClick={handleExit}/>
                    <GeneralButton width="150px" text="Next" id="btnNext" data-test="btnNext" onClick={(e) => onFromNextClicked()}/>
                </>}
                {edit && <>
                    <GeneralButton type="functional" inverted={true} width="150px" data-test="btnCancel" text="Cancel" id="btnCancel" onClick={onHandleCancel}/>
                    <GeneralButton width="150px" data-test="updateBtn" text="Update" id="btnUpdate" 
                        disabled={checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS', csrBusinessFunction)} 
                        onClick={handleUpdate}
                    />
                </>}
            </FromNavigationBtnContainer>
            <AlertMessage                
                title="Error"
                cancelText="OK"
                visible={errorModal}
                onCancel={(e) => setErrorModal(false)}
                data-test="alertMessage"
            >   
                Please select funds to be exchanged from the existing investment pools.
            </AlertMessage>
        </>
    );
}


ExchangeFrom.propTypes = {
    investmentPoolOptions: PropTypes.object,
    scheduleType: PropTypes.string,
    exchangeType: PropTypes.string,
    changeExchangeType: PropTypes.func,
    handleExit: PropTypes.func,
    handleCancel: PropTypes.func,
    handleBack: PropTypes.func,
    userId: PropTypes.string,
    edit: PropTypes.bool,
    id: PropTypes.string,
    persistContext: PropTypes.func,
    isNew: PropTypes.bool,
    resetContext: PropTypes.func
}
export default withRouter(ExchangeFrom);